import React from 'react';

export const CoveoSearchContext = React.createContext<{
  handleClose: Function;
}>({
  handleClose: () => {},
});
